"use client";

import React from 'react';
import { Shield, Settings, Check } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useCookieConsent } from '@/contexts/cookie-consent-context';
import Link from 'next/link';

export function CookieBanner() {
  const { showBanner, acceptAll, rejectAll, setShowSettings, setShowBanner } = useCookieConsent();

  if (!showBanner) return null;

  return (
    <>
      {/* Overlay semi-trasparente */}
      <div className="fixed inset-0 bg-black/40 backdrop-blur-[2px] z-[9998]" />
      
      {/* Banner Cookie */}
      <div className="fixed bottom-0 left-0 right-0 z-[9999] p-4 md:p-6 animate-in slide-in-from-bottom duration-300">
        <div className="max-w-6xl mx-auto">
          <div className="bg-gradient-to-br from-white to-gray-50 rounded-2xl shadow-2xl border border-gray-200 overflow-hidden backdrop-blur-sm">
            
            {/* Contenuto principale */}
            <div className="p-5 md:p-7">
              <div className="flex flex-col lg:flex-row gap-5 items-start lg:items-center">
                
                {/* Icona e Testo */}
                <div className="flex items-start gap-4 flex-1">
                  <div className="relative flex-shrink-0">
                    <div className="w-14 h-14 bg-gradient-to-br from-green-500 to-green-600 rounded-2xl flex items-center justify-center shadow-lg">
                      <Shield className="w-7 h-7 text-white" />
                    </div>
                    <div className="absolute -top-1 -right-1 w-4 h-4 bg-orange-500 rounded-full border-2 border-white"></div>
                  </div>
                  
                  <div className="flex-1">
                    <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-2 leading-tight">
                      Rispettiamo la tua privacy
                    </h3>
                    <p className="text-gray-600 text-sm md:text-base leading-relaxed">
                      Utilizziamo i cookie per migliorare la tua esperienza di navigazione, 
                      analizzare il traffico del sito e personalizzare i contenuti. 
                      I cookie tecnici sono sempre attivi e necessari per il funzionamento del sito.
                    </p>
                    <p className="text-xs text-gray-500 mt-2">
                      Per saperne di più:{' '}
                      <Link 
                        href="/cookie-policy" 
                        className="text-green-600 hover:text-green-700 font-semibold underline underline-offset-2"
                      >
                        Cookie Policy
                      </Link>
                      {' '}•{' '}
                      <Link 
                        href="/privacy-policy" 
                        className="text-green-600 hover:text-green-700 font-semibold underline underline-offset-2"
                      >
                        Privacy Policy
                      </Link>
                    </p>
                  </div>
                </div>
                
                {/* Pulsanti azione */}
                <div className="flex flex-col sm:flex-row lg:flex-col gap-2.5 w-full lg:w-auto lg:min-w-[200px]">
                  <Button
                    onClick={acceptAll}
                    className="bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white px-6 py-3 rounded-xl font-bold text-base shadow-lg hover:shadow-xl transition-all duration-200 flex items-center justify-center gap-2 border-2 border-green-700"
                  >
                    <Check className="w-5 h-5" strokeWidth={3} />
                    Accetta tutti
                  </Button>
                  
                  <Button
                    onClick={() => {
                      setShowSettings(true);
                      setShowBanner(false);
                    }}
                    className="bg-white hover:bg-gray-50 text-gray-900 px-6 py-3 rounded-xl font-semibold text-base shadow-md hover:shadow-lg transition-all duration-200 flex items-center justify-center gap-2 border-2 border-gray-300 hover:border-green-500"
                  >
                    <Settings className="w-5 h-5" />
                    Personalizza
                  </Button>
                  
                  <Button
                    onClick={rejectAll}
                    className="bg-transparent hover:bg-gray-100 text-gray-700 px-6 py-3 rounded-xl font-medium text-sm transition-all duration-200 flex items-center justify-center gap-2 border border-gray-300"
                  >
                    Solo necessari
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
